import styled from "styled-components"

const ArrowContainer = styled.div`
  width: 100%;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  max-width: 400px;
  height: 216px;
  @media (min-width: 640px) {
    max-width: 820px;
  }
  @media (min-width: 1200px) {
    max-width: 1350px;
  }
  pointer-events: none;
`

export default ArrowContainer
